import { Outlet } from "react-router-dom";
import { OrganizationSidebar } from "./OrganizationSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";

export function OrganizationLayout() {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <OrganizationSidebar />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
}
